/*
 * Public API Surface of angular-google-tag-manager
 */

export * from './lib/angular-google-tag-manager-config.service';
export * from './lib/angular-google-tag-manager.module';
export * from './lib/angular-google-tag-manager.providers';
export * from './lib/angular-google-tag-manager.service';
export * from './lib/google-tag-manager-config';
